/**
 * Попапы
 */
let trigger;


/**
 * Открываем
 */
function openPopup(name) {
    closePopups();

    const popup = document.querySelector(`.js-popup[data-name="${name}"]`);

    if (App.menuIsOpen) {
        App.menu.close();
    }

    if (popup) {
        popup.classList.add('_is-visible');
        App.lockScroll.lock();
    }
}


/**
 * Закрываем
 */
function closePopups() {
    document.querySelectorAll('.js-popup._is-visible').forEach(el => {
        el.classList.remove('_is-visible');
    });

    App.lockScroll.unlock();

    // Возвращаем фокус на кнопку, которой открыли (для Tab-навигации)
    if (trigger) {
        trigger.focus();
    }
}


/**
 * Биндим кнопки
 */
document.querySelectorAll('.js-open-popup').forEach(btn => {
    const name = btn.getAttribute('data-popup-name');

    btn.addEventListener('click', e => {
        e.preventDefault();
        openPopup(name);

        trigger = btn;
    });
});

document.querySelectorAll('.js-close-popup').forEach(btn => {
    btn.addEventListener('click', e => {
        e.preventDefault();
        closePopups();
    });
});



// WEBPACK FOOTER //
// ./_src/js/Popup.js